export enum UserSettingsTab {
  PROFILE = 'My Profile',
  USERS = 'Users',
  INTEGRATIONS = 'Integrations',
  ENVIRONMENTS = 'Environments',
}
